"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueItem = void 0;
class QueueItem {
    constructor(queue, index, cmd, args) {
        this.queue = queue;
        this.index = index;
        this.cmd = cmd;
        this.args = args;
    }
}
exports.QueueItem = QueueItem;
